import React, {useState, useContext} from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import OTADialog from "./OTADialog";
import {AppConfigContext} from "../../context/AppConfigContextProvider";
import axios from "axios";

export default function HierarchyOta(props) {
    const {show, handleClose, level, currentOta} = props;
    const {OTAFiles} = useContext(AppConfigContext);
    
    const [ ota, setOta ] = useState(
        Object.fromEntries(
            Object.entries(currentOta)
                .filter(([key]) => 
                    key === 'setNodeFirmwareId' || 
                    key === 'setNodeWisunFirmwareId' ||
                    key === 'setNeuralNetworkId' ||
                    key === 'setGatewayScriptId' ||
                    key === 'setGatewayWisunFirmwareId' 
            )
        )
    )

    const nodeFirmware = OTAFiles.filter( ele => ele.type === 'NODE_FIRMWARE')
    const neuralNetwork = OTAFiles.filter( ele => ele.type === 'NEURAL_NETWORK')
    const wisunFirmware = OTAFiles.filter( ele => ele.type === 'WISUN_FIRMWARE')
    const gatewayScript = OTAFiles.filter( ele => ele.type === 'GATEWAY_SCRIPT')

    // Handle OTA Values changes in the form
    function handleOTAChange(newVal){
        setOta(prevVal => ({ ...prevVal, [newVal.target.name]: Number(newVal.target.value) === 0 ? null : Number(newVal.target.value)}))
    }

    // Handle Patch submission to org or zone PATCH API
    async function handleSubmit() {
        let otaUrl = '';
        if (level === 'organization') {
            otaUrl = `/organization/${currentOta.id}/ota`;
        } else if (level === 'zone') {
            otaUrl = `/organization/${currentOta.organizationId}/zone/${currentOta.id}/ota`;
        }

        if (!otaUrl) {
            console.error('OTA URL is not defined');
            return;
        }

        try {
            const res = await axios.patch(otaUrl, ota);
            handleClose(false);
        } catch (err) {
            console.error(err);
        }
}

    return <>
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                {level==='organization' ? 
                    <Modal.Title>Organization Settings</Modal.Title>
                :
                    <Modal.Title>Zone Settings</Modal.Title>
                }
            </Modal.Header>
            <Modal.Body>
                {level === 'organization' ? 
                    <OTADialog 
                        nodeFirmware={nodeFirmware}
                        neuralNetwork={neuralNetwork}
                        sensorWisunFirmware={wisunFirmware}
                        gatewayWisunFirmware={wisunFirmware}
                        gatewayScript={gatewayScript}
                        currentOTA={ota}
                        onOTAChange={handleOTAChange}
                        hierarchy={true}
                    />
                : 
                    <OTADialog 
                        nodeFirmware={nodeFirmware}
                        neuralNetwork={neuralNetwork}
                        sensorWisunFirmware={wisunFirmware}
                        currentOTA={ota}
                        onOTAChange={handleOTAChange}
                        hierarchy={true}
                    />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={()=>{
                    setOta(currentOta)
                    handleClose(false)
                }}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Save Changes
                </Button>
            </Modal.Footer>
        </Modal>
    </>
}

HierarchyOta.propTypes = {
    show: PropTypes.func,
    handleClose: PropTypes.func,
    level: PropTypes.string,
    currentOta: PropTypes.object,
}
